import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import WhyCars from "./component";
import { fetchData } from "../../shared/meta-tags/actions";
import { fetchFAQ } from "./actions";

const mapStateToProps = ({
    meta: {tweets, isSSR, genericContent }
}) => ({
    tweets, isSSR, genericContent
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDataConnect: fetchData,
    fetchFAQConnect: fetchFAQ
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WhyCars);

